// Library methods
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

// Components
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import PackageInfo from "../PackageInfo/PackageInfo";
import { CollapseLeftIcon, CollapseRightIcon } from "src/assets/icons";

// Styles
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const PackageDrawer = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const smallerThanSm = useMediaQuery(theme.breakpoints.down("sm"));

  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (smallerThanSm && isExpanded) {
      setIsExpanded(false);
    }
  }, [isExpanded, smallerThanSm]);

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: "fit-content",
          height: "100%",
          position: "relative",
          border: "none",
        },
      }}
      variant="persistent"
      anchor="left"
      open
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: isExpanded ? "space-between" : "center",
            alignItems: "center",
            p: "10px 16px",
            gap: "8px",
          }}
        >
          {isExpanded && (
            <Typography fontSize="12px" textTransform="uppercase">
              {t("Multi-Exam Package")}
            </Typography>
          )}

          <Tooltip
            title={
              isExpanded
                ? t("Hide Multi-Exam Package")
                : t("View Multi-Exam Package")
            }
            placement="right"
          >
            <IconButton
              disabled={smallerThanSm}
              sx={{
                color: "inherit",
                p: 0,
                height: "20px",
                width: "20px",
              }}
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              {isExpanded ? (
                <CollapseLeftIcon width="20px" height="20px" />
              ) : (
                <CollapseRightIcon width="20px" height="20px" />
              )}
            </IconButton>
          </Tooltip>
        </Box>

        <Box px="16px" pb="8px">
          <PackageInfo isExpanded={isExpanded} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default PackageDrawer;
